import React, { useState } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import { theme } from '../../config/theme';

const ApprovalModal = ({ isOpen, onClose, onConfirm, action, sellerName, loading }) => {
  const [reason, setReason] = useState('');

  const handleSubmit = () => {
    if (action === 'reject' && !reason.trim()) {
      alert('Please provide a reason for rejection');
      return;
    }
    onConfirm(action === 'reject' ? reason : null);
  };

  const isApprove = action === 'approve';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={isApprove ? 'Approve Seller' : 'Reject Seller'}>
      <div>
        <p style={{ marginBottom: theme.spacing.lg, fontSize: theme.typography.fontSize.sm }}>
          {isApprove 
            ? `Are you sure you want to approve "${sellerName}"? They will be able to login and start selling.`
            : `Are you sure you want to reject "${sellerName}"? Please provide a reason:`
          }
        </p>

        {!isApprove && (
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for rejection..."
            rows={4}
            style={{
              width: '100%',
              padding: theme.spacing.md,
              border: `1px solid ${theme.colors.gray[300]}`,
              borderRadius: theme.borderRadius.md,
              fontSize: theme.typography.fontSize.sm,
              fontFamily: theme.typography.fontFamily,
              marginBottom: theme.spacing.lg,
              resize: 'vertical',
            }}
          />
        )}

        <div style={{ display: 'flex', gap: theme.spacing.md }}>
          <Button 
            variant="secondary" 
            size="md"
            fullWidth
            onClick={onClose} 
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            variant={isApprove ? 'primary' : 'danger'} 
            size="md"
            fullWidth
            onClick={handleSubmit} 
            loading={loading}
          >
            {isApprove ? 'Approve' : 'Reject'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ApprovalModal;